import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../../services/api';
import { Mail, Loader2, ArrowLeft, CheckCircle } from 'lucide-react';

/**
 * Pagina recupero password
 */
function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await authService.forgotPassword(email);
      setIsSubmitted(true);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          'Errore durante l\'invio. Riprova più tardi.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Messaggio di conferma
  if (isSubmitted) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-sm p-4 sm:p-6 animate-fadeIn">
        <div className="text-center">
          <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="text-green-600 dark:text-green-400" size={28} />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-foreground">Email inviata</h2>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">
            Se l'indirizzo email è registrato, riceverai un link per reimpostare
            la password.
          </p>
          <p className="text-xs sm:text-sm text-muted-foreground mt-4">
            Controlla anche la cartella spam.
          </p>

          <Link
            to="/login"
            className="inline-flex items-center gap-2 mt-6 text-primary hover:underline active:underline py-2 touch-manipulation"
          >
            <ArrowLeft size={16} />
            Torna al login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4 sm:p-6 animate-fadeIn">
      <div className="text-center mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-foreground">Password dimenticata?</h2>
        <p className="text-muted-foreground mt-2 text-sm sm:text-base">
          Inserisci la tua email e ti invieremo un link per reimpostare la
          password.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {error && (
          <div className="p-3 rounded-lg bg-destructive/10 text-destructive text-sm">
            {error}
          </div>
        )}

        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-2">
            Email
          </label>
          <div className="relative">
            <Mail
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
              size={20}
            />
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-3 sm:py-3.5 rounded-lg border border-input bg-background text-foreground text-base focus:outline-none focus:ring-2 focus:ring-ring"
              placeholder="nome@esempio.it"
              required
              autoComplete="email"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              autoFocus
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full py-3 sm:py-3.5 px-4 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 active:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 min-h-[48px] touch-manipulation"
        >
          {isLoading && <Loader2 className="animate-spin" size={20} />}
          Invia link di recupero
        </button>

        <Link
          to="/login"
          className="flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground active:text-foreground py-2 touch-manipulation"
        >
          <ArrowLeft size={16} />
          Torna al login
        </Link>
      </form>
    </div>
  );
}

export default ForgotPasswordPage;
